import React, { useEffect } from 'react';
import { useLoading } from '../loading_context/LoadingContext';
import { useAppVersionProvider } from './AppVersionProvider';
import COLORS from '../../resources/style/Themes';
import { LoadingNavBar } from '../../components/navbar/LoadingNavBar';
import { useUserContext } from '../user_context/UserProvider';
import { StringKeys } from '../../resources/strings/StringKeys';
import { useTranslation } from 'react-i18next';
import { Settings } from '@mui/icons-material';

/**
 * This screen displays when an App Version object is created via the App Versioning web page available to Safeguard Developers.
 * If an app version object exists with a rollout timestamp that is before the current time, the go live is set to true, and update complete is set to false, this page will show.
 * Once the update complete is set to true, the user will need to refresh the page to see the new version.
 */

const MaintenanceIndicator = () => {
  const { pageLoading, setPageLoading } = useLoading();
  const { safeguardView, isSafeguardDev } = useUserContext();
  const { inMaintenance, rolloutTimestamp, setInMaintenance } =
    useAppVersionProvider();
  const { t } = useTranslation();

  useEffect(() => {
    if (inMaintenance && !safeguardView) setPageLoading(false);
  }, [inMaintenance, safeguardView, pageLoading]);

  useEffect(() => {
    if (rolloutTimestamp) {
      const currentTime = Date.now();
      const timeUntilRollout = rolloutTimestamp - currentTime;
      //Safeguard developers bypass the maintenance screen to allow for testing on completion of update.
      if (timeUntilRollout <= 0 && !isSafeguardDev) {
        setInMaintenance(true);
      } else {
        const timer = setTimeout(() => {
          setInMaintenance(true);
        }, timeUntilRollout);

        return () => clearTimeout(timer);
      }
    }
  }, [rolloutTimestamp]);

  if (inMaintenance && !safeguardView) {
    return (
      <>
        {!isSafeguardDev && <LoadingNavBar />}{' '}
        {/* LoadingNavBar is shown to regular users. Developers will see the normal navbar to allow for switching between developer and user view. */}
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <div
            style={{
              marginBottom: '20px',
              position: 'relative',
              width: '150px',
              height: '150px',
            }}
          >
            {/* First Gear */}
            <Settings
              style={{
                position: 'absolute',
                top: '10px',
                left: '10px',
                width: '100px',
                height: '100px',
                color: COLORS.SAFEGUARD_BLUE,
                animation: 'spin 5s linear infinite',
                transformOrigin: 'center',
              }}
            />
            {/* Second Gear */}
            <Settings
              style={{
                position: 'absolute',
                top: '58px',
                left: '60px',
                width: '100px',
                height: '100px',
                color: COLORS.SAFEGUARD_ORANGE,
                animation: 'spin-reverse 5s linear infinite',
                transformOrigin: 'center',
              }}
            />
          </div>
          <h2>{t(StringKeys.WE_WILL_BE_BACK_SOON)}</h2>
          <h4 style={{ marginTop: 0, width: '50%' }}>
            {t(
              StringKeys.THE_SAFEGUARD_EQUIPMENT_WEB_APPLICATION_IS_CURRENTLY_UNDER_MAINTENANCE,
            )}
          </h4>
        </div>
      </>
    );
  }

  return null;
};

export default MaintenanceIndicator;
